var l;(function(e){e.black="black",e.outlineBlack="outline-black",e.black65="black-65",e.white="white",e.outlineWhite="outline-white",e.white65="white-65",e.unstyled="unstyled"})(l||(l={}));export{l as ButtonVariant};
